import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/landing/logo.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_3 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "othres" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass([
      'navbar navbar-expand-lg bg-opacity-25 fixed-top',
      { sticky: _ctx.isSticky },
    ]),
    id: "navbar"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        class: "navbar-brand me-xl-5 me-3",
        to: "/"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "logo"
          }, null, -1)
        ]))]),
        _: 1
      }),
      _cache[9] || (_cache[9] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarSupportedContent",
        "aria-controls": "navbarSupportedContent",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              class: "nav-link fs-16 fw-medium text-body hover px-0 px-md-2 mx-1 mx-xl-0 px-xl-4",
              to: "/"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Home ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              class: "nav-link fs-16 fw-medium text-body hover px-0 px-md-2 mx-1 mx-xl-0 px-xl-4",
              to: "/features"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Features ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_RouterLink, {
              class: "nav-link fs-16 fw-medium text-body hover px-0 px-md-2 mx-1 mx-xl-0 px-xl-4",
              to: "our-team"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Our Team ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_RouterLink, {
              class: "nav-link fs-16 fw-medium text-body hover px-0 px-md-2 mx-1 mx-xl-0 px-xl-4",
              to: "/faq"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" FAQ’s ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_RouterLink, {
              class: "nav-link fs-16 fw-medium text-body hover px-0 px-md-2 mx-1 mx-xl-0 px-xl-4",
              to: "/contact"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" Contact ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_RouterLink, {
              class: "nav-link fs-16 fw-medium text-body hover px-0 px-md-2 mx-1 mx-xl-0 px-xl-4",
              to: "/dashboard"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" Admin ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_RouterLink, {
            to: "/authentication/login",
            class: "btn btn-outline-primary-div py-2 px-4 fw-medium fs-16 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "ri-login-box-line fs-18 position-relative top-2" }, null, -1),
              _createElementVNode("span", { class: "ms-1" }, "Login", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            to: "/authentication/register",
            class: "btn btn-primary-div py-2 px-4 fw-medium fs-16 text-white ms-3 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "ri-user-line fs-18" }, null, -1),
              _createElementVNode("span", { class: "ms-1" }, "Register", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}